/*!
 * Copyright © 2025. Verizon Connect Ireland Limited. All rights reserved.
 */

import { Inject, Injectable } from '@angular/core';

import { IAppConfig } from '../../core/config/app-config.interfaces';
import { APP_CONFIG } from '../../core/config/app-config.token';

@Injectable()
export class UrlsService {
  constructor(@Inject(APP_CONFIG) private readonly appConfig: IAppConfig) {}

  public apiUrl = this.appConfig.apiUrl;
  public initialiseApiUrl = `${this.apiUrl}/v1/setPassword/initialise`;
  public completeApiUrl = `${this.apiUrl}/v1/setPassword/complete`;

  public revealUrl = this.appConfig.revealUrl;
}
